import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { CollectorStat } from './types'

// actions
export const FETCH_COLLECTOR_STATS = 'profile/FETCH_COLLECTOR_STATS'
export const FETCH_COLLECTOR_STATS_SUCCESS = 'profile/FETCH_COLLECTOR_STATS_SUCCESS'

export const StatsActions = {
  fetchAllCollectorStats: () => createAction(FETCH_COLLECTOR_STATS),
  fetchCollectorStatsSuccess: (stats: CollectorStat) => createAction(FETCH_COLLECTOR_STATS_SUCCESS, stats)
}

export type StatsActions = ActionsUnion<typeof StatsActions>
